import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const UnitMasterPopup = (props) => {
    return (
        <ModalBasic
            id="unitMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Unit master</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Unit description</label>
                        <TextInput type='text'
                            id='unitDesc' name='unitDesc'
                            value={props.unitObject.unitDesc}
                            handleChange={(event) => props.handleChange(event, 'unitDesc')}
                            className={props.validState?.error?.unitDesc !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Short code</label>
                        <TextInput type='text'
                            id='shortCode' name='shortCode'
                            value={props.unitObject.shortCode}
                            handleChange={(event) => props.handleChange(event, 'shortCode')}
                            placeholder="Example:- KG, MT"
                            className={props.validState?.error?.shortCode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.unitObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}